import { IRetailerRepositoryResponse } from "@/core/repositories/lookup";
import { LookupRepository } from "@/infrastructure/repositories/lookup";

export class GetRetailerUseCase {
  constructor(private readonly lookupRepository: LookupRepository) {}

  async execute(): Promise<IRetailerRepositoryResponse> {
    return this.lookupRepository.getRetailers();
  }
}

